import type { ExperimentName } from './registry';

/**
 * Treatments are bucketed by the hotpads `guid` cookie. Including the guid in
 * the cache key means a guid rotation (logout/login, cookie cleared, account
 * switch) yields a cache miss instead of serving the prior identity's
 * treatment under `staleTime: Infinity`.
 */
export const experimentKeys = {
  treatment: (name: ExperimentName, guid: string | undefined) =>
    ['experiment', 'treatment', name, guid ?? null] as const,
};
